import ResetIdentityModal from "./ResetIdentityModal"

export default ResetIdentityModal
